import { ucsc, aquinas, hrcc, bosco } from "src/assets";

// Function to calculate duration
function calculateDuration(startDate, endDate = new Date()) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const years = end.getFullYear() - start.getFullYear();
  const months = end.getMonth() - start.getMonth();
  const totalMonths = years * 12 + months;
  const displayYears = Math.floor(totalMonths / 12);
  const displayMonths = totalMonths % 12;

  if (displayYears > 0 && displayMonths > 0) {
    return `${displayYears} yr ${displayMonths} mos`;
  } else if (displayYears > 0) {
    return `${displayYears} yr${displayYears > 1 ? "s" : ""}`;
  } else {
    return `${displayMonths} mos`;
  }
}

// Education Data
export const EDUCATION = [
  {
    id: 1,
    institution: "University of Colombo School of Computing",
    logo: ucsc,
    degree: "Bachelor of Computer Science",
    field: "Computer Science",
    startDate: "2020-01-01",
    endDate: "2024-12-01",
  },
  {
    id: 2,
    institution: "Aquinas College of Higher Studies",
    logo: aquinas,
    degree: "Diploma in English Language and Literature",
    field: "English Language and Literature, General",
    startDate: "2019-12-01",
    endDate: "2020-08-01",
  },
  {
    id: 3,
    institution: "Hanwella Rajasinghe Central College",
    logo: hrcc,
    degree: "Both G.C.E (O/L) & (A/L)",
    field: "G.C.E (O/L) - 7A2B & G.C.E (A/L) - 2A1B",
    startDate: "2008-01-01",
    endDate: "2019-12-01",
  },

  {
    id: 4,
    institution: "St John Bosco's College",
    logo: bosco,
    degree: "Until Grade 5 Scholarship",
    field: "Results 154/200 (Pass Mark (AY 2007): 144)",
    startDate: "2002-01-01",
    endDate: "2007-12-01",
  },
];

// Add calculated durations
EDUCATION.forEach((edu) => {
  edu.duration = `${new Date(edu.startDate).toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  })} - ${new Date(edu.endDate).toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  })} · ${calculateDuration(edu.startDate, edu.endDate)}`;
});